import { render, staticRenderFns } from "./ShowPostPage.vue?vue&type=template&id=3370e888&scoped=true&"
import script from "./ShowPostPage.vue?vue&type=script&lang=js&"
export * from "./ShowPostPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3370e888",
  null
  
)

export default component.exports